import * as apiPasswordReminder from '@/api/password-reminder'

const passwordReminder = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {

  },
  getters: {
  },
  mutations: {
  },
  actions: {
  }
}

export default passwordReminder
